export var formMessageStyles = {
    root: function () {
        return {
            paddingLeft: 0,
        };
    },
};
//# sourceMappingURL=formMessage-styles.js.map